import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose } from 'class-transformer';

export class VicomStatus extends AdditionalInfoImpl {
  irma: number;
  version: string;
  @Expose({ name: 'people_counter_status' })
  peopleCounterStatus: string;
}
